import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import getApiBaseUrl from '@/utils/getBaseUrl';

interface Payload {
  id: string;
  _id?: string;
  mortgageId?: string;
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  auth0Id: string;
}

export default function useUpdateAgent() {
  const queryClient = useQueryClient();
  const navigation = useNavigate();

  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      navigation('/dashboard');

      const { auth0Id, ...rest } = payload;

      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/users/agents/${auth0Id}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(rest),
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['ADMIN_AGENTS'] });
    },
  });
}
